import {DEFAULT_COLORS} from '@constants/colors';

const axisCommon = function () {
	return {
		axisLine: {
			lineStyle: {
				color: '#6E7079',
			},
		},

		axisLabel: {
			color: null,
		},

		splitLine: {
			lineStyle: {
				color: ['#E0E6F1'],
			},
		},

		splitArea: {
			areaStyle: {
				color: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)'],
			},
		},

		minorSplitLine: {
			lineStyle: {
				color: '#F4F7FD',
			},
		},
	};
};

const defaultLightTheme = {
	color: DEFAULT_COLORS,

	/**
	 * ECharts 5 bar spacing.
	 */
	bar: {
		defaultBarGap: '20%',
	},

	textStyle: {
		fontFamily: 'Inter, Arial, sans-serif',
	},

	legend: {
		/**
		 * ECharts 5 default placement.
		 */
		top: 0,
		bottom: null,
		itemGap: 10,

		textStyle: {
			fontWeight: 600,
			color: 'var(--tempo-colors-text-neutral-secondary-default)',
		},
	},

	axisPointer: {
		lineStyle: {
			color: '#B9BEC9',
		},

		shadowStyle: {
			color: 'rgba(210,219,238,0.2)',
		},

		label: {
			backgroundColor: 'auto',
			color: '#fff',
		},

		handle: {
			color: '#333',
			shadowBlur: 3,
			shadowColor: '#aaa',
			shadowOffsetX: 0,
			shadowOffsetY: 2,
		},
	},

	dataZoom: {
		/**
		 * ECharts 5 defaults.
		 */
		borderRadius: 3,
		defaultLocationEdgeGap: 7,

		fillerColor: 'rgba(162, 56, 255, 0.25)',
		borderColor: '#EAD3FF',

		dataBackground: {
			lineStyle: {
				color: '#DAB0FF',
			},

			areaStyle: {
				color: '#DAB0FF',
				opacity: 0.2,
			},
		},

		selectedDataBackground: {
			lineStyle: {
				color: '#A238FF',
				width: 1,
			},

			areaStyle: {
				color: '#A238FF',
				opacity: 0.2,
			},
		},

		handleStyle: {
			color: '#fff',
			borderColor: '#EAD3FF',
		},

		moveHandleStyle: {
			color: '#D2DBEE',
			opacity: 0.7,
		},

		textStyle: {
			color: '#6E7079',
		},

		brushStyle: {
			color: 'rgba(162, 56, 255, 0.35)',
			opacity: 1,
		},

		emphasis: {
			handleStyle: {
				color: '#F3E7FF',
				borderColor: '#C37EFF',
			},

			moveHandleStyle: {
				color: '#C37EFF',
				borderColor: '#C37EFF',
				opacity: 0.7,
			},
		},
	},

	visualMap: {
		backgroundColor: 'rgba(0,0,0,0)',
		borderColor: '#ccc',
		contentColor: '#5793f3',
		inactiveColor: '#aaa',
		padding: 5,

		indicatorStyle: {
			shadowColor: 'rgba(0,0,0,0.2)',
		},

		textStyle: {
			color: '#333',
		},
	},

	map: {
		defaultItemStyleColor: '#eee',

		label: {
			color: '#000',
		},

		itemStyle: {
			borderColor: '#444',
			areaColor: '#eee',
		},

		emphasis: {
			label: {
				color: 'rgb(100,0,0)',
			},

			itemStyle: {
				areaColor: 'rgba(255,215,0,0.8)',
			},
		},

		select: {
			label: {
				color: 'rgb(100,0,0)',
			},

			itemStyle: {
				color: 'rgba(255,215,0,0.8)',
			},
		},
	},

	tooltip: {
		axisPointer: {
			crossStyle: {
				color: '#999',
			},
		},

		textStyle: {
			color: '#666',
		},

		backgroundColor: '#fff',
		borderWidth: 1,
		defaultBorderColor: '#fff',
	},

	timeAxis: axisCommon(),
	logAxis: axisCommon(),
	valueAxis: axisCommon(),
	categoryAxis: axisCommon(),

	line: {
		/**
		 * ECharts 5 default.
		 */
		symbolSize: 4,
	},
};

export default defaultLightTheme;
